<template>
    <h3 v-if="showHeading(1)">Suunnittelutiedot</h3>
    <el-form :model="suunnittelutiedot" @submit.prevent ref="form" :inline="false" size="small">
        <el-row :gutter="20">
            <el-col v-if="isSelected('nimike')" :span="24" >
                <el-form-item>
                    <ComCascaderSearch v-model="hakuModel" />
                </el-form-item>
                <el-form-item>
                    <el-cascader-panel
                    :options="nodes"
                    :props="{
                        disabled: false,
                        multiple: true,
                        checkOnClickLeaf: false,
                    }"
                    size="small"
                    v-model="selectedNodes"
                    style="width: 100%"
                    >
                        <template #default="{ node, data }">
                            <span v-if="!node.isLeaf || !node.checked">{{ data.label }}</span>
                            <span v-else>
                                <el-link :icon="Edit" @click="cascaderFocus(data.value)">
                                    <div style="overflow: hidden; text-overflow: ellipsis;">
                                        &nbsp; {{ data.label }}
                                    </div>    
                                </el-link>
                            </span>
                        </template>
                    </el-cascader-panel>
            </el-form-item>
            </el-col>
            <el-col :span="24" v-if="showTiedot.length > 0">
                <h3>Tarkenna nimikkeiden haku termejä</h3>
                <template v-for="(selectedNimike, i) in searchForm.nimike" :key="selectedNimike.id">
                    <template v-if="isSelectedNimike(selectedNimike.id) && searchForm.nimike">
                        <ComHakuSuunnittelutiedotOminaisuudet :show="isSelectedNimike(selectedNimike.id)" v-model="searchForm.nimike[i]" />
                        <el-form-item>
                            <ComCancelButton @click="cascaderFocus(selectedNimike.id)">Peruuta</ComCancelButton>
                        </el-form-item>
                    </template>
                </template>
            </el-col>
            <el-col :span="24" v-if="isSelected('nimike-tasmennys')">
                <el-form-item label="Nimikkeen täsmennys">
                    <el-input 
                        v-model="searchForm['nimike-tasmennys']" 
                        placeholder="Hae kaikista nimikkeistä tai valituista"
                        clearable
                    />
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script setup lang="ts">
import { computed, ref, toRef, watch } from 'vue';
import { useHakuComponent } from './haku';
import { setNodes, useNimikeKategoria } from '@/methods/nimikkeetComposables';
import ComHakuSuunnittelutiedotOminaisuudet from './ComHakuSuunnittelutiedotOminaisuudet.vue';
import { Edit } from '@element-plus/icons-vue'
import ComCancelButton from '@/components/common/buttons/ComCancelButton.vue';
import ComCascaderSearch from '@/components/common/ComCascaderSearch.vue';
import { useHakuSelection } from '@/methods/hakuSelectionComposables';

const { searchForm, selectedNodes, isSelected, showHeading } = useHakuComponent()
const { model: hakuModel } = useHakuSelection(selectedNodes)
const suunnittelutiedot = computed(() => searchForm.value.nimike)
const { nimikeKategoriat } = useNimikeKategoria(toRef(true))
const showTiedot = ref<number[]>([])
const nodes = computed(() => setNodes(nimikeKategoriat.value ?? []))

const isSelectedNimike = (id : number | undefined) => {
    return id !== undefined && showTiedot.value?.indexOf(id) !== -1
}
const removeFromSelected = (id : number) => {
    showTiedot.value = showTiedot.value.filter(s => s !== id)
}
const cascaderFocus = (id: number | undefined) => {
    if(id === undefined) {
        return
    }
    if(isSelectedNimike(id) === false) {
        showTiedot.value.push(id)
    }
    else {
        removeFromSelected(id)
        
        const index = searchForm.value.nimike?.findIndex(n => n.id === id) ?? -1
        if(index !== -1 && searchForm.value.nimike) {
            searchForm.value.nimike[index] = { id: id }
        }
    }
}

watch(() => selectedNodes.value.map(node => node[2]), (newIds, oldIds) => {
    const removedIds = oldIds.filter(id => !newIds.includes(id))
    const addedIds = newIds.filter(id => !oldIds.includes(id))

    removedIds.forEach(id => {
        removeFromSelected(id);
        searchForm.value.nimike = searchForm.value.nimike?.filter(n => n.id !== id) || []
    })

    addedIds.forEach(id => {
        if (!searchForm.value.nimike?.find(n => n.id === id)) {
            searchForm.value.nimike?.push({ id })
        }
    })

    if (newIds.length === 0) {
        showTiedot.value = []
    }
})
</script>